import { Link } from 'gatsby';
import React, { LegacyRef } from 'react';

import { ReactComponent as CheckIcon } from '/src/images/icons/check.svg';

import { HreflangTag } from '../../helpers/rendered-page-creation/calculate-hreflang-tags';
import { ILibraryLanguage } from '../../queries/fragments/libraryLanguage';

interface LanguageSelectorWidgetProps {
  el?: LegacyRef<HTMLDivElement> | undefined;
  languageSelectorClass?: string;
  node_locale: string;
  variant: 'compact' | 'dropdown';
  hrefLangTags: HreflangTag[];
  primaryLanguage: ILibraryLanguage;
  secondaryLanguages: ILibraryLanguage[];
}

export const LanguageSelectorWidget = ({
  el,
  languageSelectorClass,
  node_locale,
  variant,
  hrefLangTags,
  primaryLanguage,
  secondaryLanguages,
}: LanguageSelectorWidgetProps) => {
  const [sorted] = React.useState(
    [primaryLanguage, ...secondaryLanguages].sort((a, b) =>
      a?.languageCode > b?.languageCode ? 1 : -1,
    ),
  );

  const isSelected = (lang: string) => {
    return lang === node_locale.toLowerCase();
  };

  const matchCorrectLink = (lang: string) => {
    const index = hrefLangTags?.findIndex((tag) => tag.hreflang === lang);
    if (index !== -1) {
      return hrefLangTags?.[index].href;
    } else {
      return `/${lang}`;
    }
  };

  if (variant === 'dropdown') {
    return (
      <div
        ref={el}
        id="language-selector"
        className={`z-10 min-w-[10rem] overflow-hidden rounded-lg border border-neutral-grey-400 bg-brand-white focus-within:outline focus-within:outline-4 focus-within:outline-offset-3 focus-within:outline-neutral-grey-400  ${languageSelectorClass}`}
      >
        <ul className="my-4 mr-3 max-h-24 overflow-y-auto scrollbar-default">
          {sorted.map((lang, i) => (
            <li key={`dropdown-${i}`}>
              <Link
                to={matchCorrectLink(lang?.languageCode)}
                className={`flex items-center justify-between border-l-4 border-l-transparent py-1 pl-5 pr-3 text-bodym hover:border-neutral-grey-400 hover:bg-background-primary-light focus:border-neutral-grey-400 focus:bg-background-primary-light focus:outline-none ${
                  isSelected(lang.languageCode) ? 'font-bold' : ''
                }`}
              >
                <span>{lang.nativeName ? lang.nativeName : lang.name}</span>
                {isSelected(lang.languageCode) && (
                  <CheckIcon className="ml-4 text-icon-dark" />
                )}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  if (variant === 'compact') {
    return (
      <ul className={`flex ${languageSelectorClass}`}>
        {sorted.map((lang, i) => (
          <li
            key={`compact-${i}`}
            className="flex items-center text-text-light after:mx-1 after:content-['/'] last:after:content-none"
          >
            <Link
              to={matchCorrectLink(lang?.languageCode)}
              className={`flex text-bodym decoration-2 underline-offset-6 ${
                isSelected(lang.languageCode)
                  ? 'font-bold text-text-default underline'
                  : ''
              }`}
            >
              {lang.languageCode.toUpperCase()}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
  return null;
};
